import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import CommonBtn from '../atoms/commonBtn'
import LogoSvg from '../atoms/logoSvg'
import SearchInput from '../atoms/searchInput'
import useRouteParam from '../../hooks/useRouteParam'
import HelpSpNav from '../molecules/help/helpSpNav'
import HelpSpSearch from '../molecules/help/helpSpSearch'

const Wrapper = styled.header`
  display: flex;
  align-items: center;
  padding: 4px 0 0 10px;
  height: 80px;
  justify-content: space-between;
  position: relative;

  a {
    color: #00b5a6;
  }

  .logo-link {
    height: 64px;
    display: flex;
    align-items: center;

    .logo {
      margin: 0 5px 0 0;
      padding: 0;
      width: 170px;
    }

    .txt {
      font-size: 0.6em;
      line-height: 1em;
    }

    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }

  .search-input {
    input {
      height: 34px !important;
      font-size: 14px;
    }
  }

  .search-btn {
    height: 40px;
  }

  .right-btn-area {
    display: flex;
    width: 320px;
    justify-content: space-between;
    align-items: center;
    position: relative;

    button {
      padding: 0 15px;
      min-width: 30px;
    }

    a {
      display: block;
      margin: 0 0 0 10px;
    }
  }

  &.search-head {
    .nav-search {
      display: none;
    }

    .search-input-wrap {
      //p,
      //button {
      //  display: none;
      //}
    }
  }

  // ${BreakPoints.xLarge} {
  //   .right-btn-area {
  //     width: 290px;
  //
  //     a {
  //       display: block;
  //       margin: 0 0 0 8px;
  //     }
  //   }
  // }

  ${BreakPoints.large} {
    position: fixed;
    z-index: 100;
    top: 0;
    height: 45px;
    width: 100vw;
    background: #ffffff;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    padding: 3px 10px 0;
    justify-content: flex-start;

    .logo-link {
      height: 40px;

      .logo {
        width: 140px;
      }

      .txt {
        color: #243750;
      }
    }

    > .search-input-wrap {
      display: none;
    }

    .right-btn-area {
      display: none;
    }

    .p-nav-area {
      top: 0;
    }
  }
`

type Props = {
  /** クラス名 */
  className?: string
}

/**
 * ヘッダー
 * @constructor
 */
const Header = (props: Props): JSX.Element => {
  const { className = '' } = props
  const routeParam = useRouteParam('/support')
  const routeParam2 = useRouteParam('/')
  const routeParam3 = useRouteParam('https://app.kintaicloud.jp')
  return (
    <Wrapper className={className}>
      <h1>
        <Link to={useRouteParam('/help/')} className="logo-link">
          <LogoSvg />
          <span className="txt">ヘルプ</span>
        </Link>
      </h1>
      <SearchInput />
      <HelpSpSearch />
      <HelpSpNav />
      <div className="right-btn-area">
        <a href={routeParam} target="_blank" rel="noreferrer">
          お問い合わせ
        </a>
        <a
          href={routeParam2}
          target="_blank"
          className="official "
          rel="noreferrer"
        >
          製品サイト
        </a>
        <CommonBtn size="large" onClick={() => window.open(routeParam3)}>
          ログイン
        </CommonBtn>
      </div>
    </Wrapper>
  )
}

export default Header
